import React, { Component } from 'react';
import { isEmpty } from "lodash";

import Pagination from '../../../container/MUI/Pagination';
import { AddRounded } from '@mui/icons-material';

import { 
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableFooter,
    TablePagination,
    Box,
    TableContainer,
    Fab,
    Grid
} from '@mui/material';
import SalaryCatForm from './SalaryCatForm';
import Creatable from '../../common/Creatable';

class SalaryCatsList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 15,
        openDetails: false,
        salary_cat: {},
        searchValue: ""
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    // onPageChange = (pageOfItems, currentPage, rowsPerPage) => {
    //     this.setState({ pageOfItems, currentPage, rowsPerPage });
    // }
    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    componentWillMount() {
        window.scrollTo(0, 0);
    }
    handleChange = (e) => {
        const { value } = e.target;

        this.setState({
            "searchValue": value.toLowerCase()
        })
    }
    getSalaryCatList = () => {
        const {  SALARY_CATS ,CATEGORIES, searchCat } = this.props
        const { rowsPerPage, page, searchValue  } = this.state;


        if ( SALARY_CATS && !isEmpty(SALARY_CATS) && !isEmpty(CATEGORIES.CHILD) ){

            let list = Object.values(SALARY_CATS)
            if( searchCat != null && !isEmpty(searchCat.value) ){
                const search = SALARY_CATS[searchCat.value]
                if (search){
                    list = [SALARY_CATS[searchCat.value]]
                }else{
                    list = []
                }
            }


            if (list ){
                return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => 
                    (
                        <TableRow hover key={item.salary_cat_id} className="clickable"
                            onClick={() => this.setState({ openDetails: true, salary_cat: item })}    
                            title="Voir le Détail"
                        >
                            <TableCell>{item?.salary_cat_name}</TableCell>
                            <TableCell>{CATEGORIES.CHILD[item?.salary_cat_parent]?.category_name || 'NA'} </TableCell>
                            <TableCell>{CATEGORIES.CHILD[item?.salary_cat_parent]?.category_accounting_id || 'NA'}</TableCell>
                        </TableRow>
                    )
                )
            }else{
                return <p>Error: 0001 : Aucune categorie trouvée : Veuillez le service IT </p>
            }

        }
    }

    handleClose = () => {
		this.setState({ 
            openDetails: false,
            salary_cat: {},
            openForm: false,
            openSalaryCat: false,
        });
    };    
        

    render() {
        const { SALARY_CATS, CATEGORIES } = this.props;
        const { rowsPerPage, page, openSalaryCat } = this.state;
        console.log('==== STATE SALARY_CATS LIST ================================');
        console.log(this.state);
        console.log('====================================');
        return (
               
            <Box>
                <Typography variant="h6" id="tableTitle">
                    Liste des Rubriques
                </Typography>
                <Grid container spacing={2}>
                    <Grid item sm={10} >
                        <Creatable
                            label="Rechercher"
                            id="searchCat"
                            options={ SALARY_CATS && CATEGORIES &&  Object.values(SALARY_CATS).map( item => ({
                                label: `${CATEGORIES.CHILD[item.salary_cat_parent]?.category_accounting_id} - ${item.salary_cat_name}`,
                                value: item.salary_cat_id,
                            })) }
                            value={this.props.searchCat}
                            onChange={this.props.handleChangeCat}
                            name="searchCat"
                        />
                    </Grid>
                    <Grid item sm={2} >
                        <Fab color="secondary" 
                            onClick={() => this.setState({ openSalaryCat: true })} 
                            title="Créer Rubrique"
                            size="small"
                        >
                            <AddRounded />
                        </Fab>
                    </Grid>
                </Grid>
                
                {openSalaryCat &&
                    <SalaryCatForm handleClose={() => this.setState({ openSalaryCat: false })} {...this.props} />
                }
                {SALARY_CATS && !isEmpty(SALARY_CATS) && 
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Libellé</TableCell>
                                    <TableCell>Categorie</TableCell>
                                    <TableCell>Compte</TableCell>
                                   
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.getSalaryCatList()}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 15]}
                                        colSpan={4}
                                        count={Object.keys(SALARY_CATS).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        onPageChange={this.handleChangePage}
                                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                                        ActionsComponent={Pagination}
                                        labelRowsPerPage="Lignes par Page"
                                    />
                                </TableRow>
                            </TableFooter>

                            {/* <TableFooterPagination
                                colSpan={4}
                                items={filteredList} 
                                onPageChange={this.onChangePage} 
                                initialPage={this.state.currentPage} 
                            /> */}
                        </Table> 
                    </TableContainer>
                }
            </Box>
                       
        );
    }
}

export default SalaryCatsList;